const redirects = {
   'url1' : { 
      landing_page : 'https://reaktion.se/', 
      name: "init-redirect" 
   }
   
};

export default redirects